// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___1cAOA","body":"body___1Kjd5"};